import React from "react";
import { ADMIN_TYPE, AdminUser } from "../../models/user";
import { ActionIcon, Box, Group, Menu, Tooltip } from "@mantine/core";
import { PencilSimpleIcon, TrashIcon } from "@phosphor-icons/react";
import { DataTable } from "mantine-datatable";

interface Props {
  users: AdminUser[]
  currentUser: AdminUser
  onEditEmail: (user: AdminUser) => void
  onEditPassword: (user: AdminUser) => void
  onEditAdminType: (user: AdminUser) => void
  onDelete: (user: AdminUser) => void
}

const getAdminTypeLabel = (admin_type: number): string => {
  if (admin_type === ADMIN_TYPE.ADMIN) return '管理者'
  if (admin_type === ADMIN_TYPE.GENERAL) return '一般'
  return ''
}

export const UsersTable: React.FC<Props> = ({
  users,
  currentUser,
  onEditEmail,
  onEditPassword,
  onEditAdminType,
  onDelete,
}) => {
  const columns = [
    {
      accessor: 'email',
      title: 'メールアドレス',
    },
    {
      accessor: 'admin_type',
      title: 'タイプ',
      width: 120,
      render: (user: AdminUser) => getAdminTypeLabel(user.admin_type),
    },
    {
      accessor: 'actions',
      title: '操作',
      width: 120,
      textAlign: 'center' as const,
      render: (user: AdminUser) => {
        const isSelf = user.id === currentUser.id
        const isAdmin = currentUser.admin_type === ADMIN_TYPE.ADMIN
        const canEdit = isAdmin || isSelf
        const canDelete = isAdmin && !isSelf
        return (
          <Group gap={4} justify="center" wrap="nowrap">
            {canEdit && (
              <Menu>
                <Menu.Target>
                  <ActionIcon variant="subtle" color="gray">
                    <PencilSimpleIcon size={16} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item onClick={() => onEditEmail(user)}>メールアドレス変更</Menu.Item>
                  <Menu.Item onClick={() => onEditPassword(user)}>パスワード変更</Menu.Item>
                  {isAdmin && !isSelf && (
                    <Menu.Item onClick={() => onEditAdminType(user)}>権限変更</Menu.Item>
                  )}
                </Menu.Dropdown>
              </Menu>
            )}
            {canDelete && (
              <Tooltip label="削除">
                <ActionIcon variant="subtle" color="red" onClick={() => onDelete(user)}>
                  <TrashIcon size={16} />
                </ActionIcon>
              </Tooltip>
            )}
          </Group>
        )
      },
    },
  ]

  return (
    <Box style={{ border: '1px solid #0000001A', borderRadius: 8, overflow: 'hidden', width: '60%' }}>
      <DataTable
        withColumnBorders
        records={users}
        idAccessor="id"
        noRecordsText="IDが登録されていません"
        styles={{
          root: { border: 'none' },
          header: { backgroundColor: '#00000008' },
        }}
        columns={columns}
      />
    </Box>
  )
}
